import * as types from './types'
import Vue from 'vue'

export default {
  [types.INIT_SHOP](state, { checkout, bottles, masterclasses }) {
    Vue.set(state, 'checkout', checkout)
    Vue.set(state, 'bottles', bottles)
    Vue.set(state, 'masterclasses', masterclasses)
  },
  [types.UPDATE_CHECKOUT](state, { checkout }) {
    Vue.set(state, 'isLoading', false)
    Vue.set(state, 'checkout', checkout)
  },
  [types.CHECKOUT_LOADING](state, loading) {
    Vue.set(state, 'isLoading', loading)
  },
  [types.SET_HIGHEST_PRODUCT_TYPE](state, value) {
    Vue.set(state, 'lastTypeProduct', value)
  }
}
